import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { LabelHub } from '@bixi/label-angular';
import { NzCascaderOption } from 'ng-zorro-antd/cascader';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { MOperationsFullscreenComponent } from './operations-fullscreen.component';
import { MOperationsTemplateService } from './operations-template.service';
import { IMOperation } from './typings';
import { padRotationList } from './utils';

@Component({
  selector: 'm-operations',
  exportAs: 'mOperations',
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: true,
  template: `
    <div class="m-operations">
      <nz-space>
        <ng-container *ngFor="let operation of mOperations">
          <ng-container *ngIf="operation.visible ? operation.visible() : true">
            <ng-container *ngIf="!operation.buildIn">
              <nz-space-item *ngIf="!operation.divider">
                <div
                  class="m-operations-item {{ operation.classnames }}"
                  [class.disabled]="operation.disabled ? operation.disabled() : false"
                >
                  <div
                    *ngIf="!operation.children"
                    class="m-operations-item-inner"
                    (click)="onOperationClick(operation)"
                    [class.disabled]="operation.disabled ? operation.disabled() : false"
                    [class.m-operations-item-inner-active]="operation.active ? operation.active() : false"
                  >
                    <ng-container *ngIf="operation.cascader; else elseTemplate">
                      <!--cascader级联操作模式-->
                      <nz-cascader
                        [nzShowInput]="false"
                        [(ngModel)]="operation.cascader.selectedValues"
                        [nzOptionRender]="renderTpl"
                        [nzOptions]="operation.cascader.options!"
                        (nzSelectionChange)="onCascaderSelection($event, operation)"
                        [nzMenuClassName]="'m-operations-item-cascader'"
                        [nzLoadData]="operation.cascader.loadData!"
                        (ngModelChange)="onCascaderChange($event, operation)"
                      >
                        <div [class.horizontal]="operation.direction === 'horizontal'">
                          <div class="icon">
                            <i nz-icon [nzType]="getString(operation.icon)!" [style.fontSize]="operation.iconSize"></i>
                          </div>
                          <div class="text">
                            {{ cascaderText ? cascaderText : getString(operation.label) }}
                          </div>
                          <div class="icon">
                            <i nz-icon nzType="caret-down" nzTheme="outline"></i>
                          </div>
                        </div>
                      </nz-cascader>
                      <ng-template #renderTpl let-option>
                        <div class="m-operations-item-cascader-template">
                          <img
                            *ngIf="option.thumbnail"
                            [src]="option.thumbnail"
                            nz-popover
                            nzPopoverPlacement="rightTop"
                            [nzPopoverContent]="contentTemplate"
                            alt="cascader-img"
                          />
                          <span>{{ option.label }}</span>
                          <ng-template #contentTemplate>
                            <div class="m-operations-item-cascader-thumbnail">
                              <img [src]="option.thumbnail" alt="" />
                            </div>
                          </ng-template>
                        </div>
                      </ng-template>
                    </ng-container>
                    <ng-template #elseTemplate>
                      <!--其他的展示模式-->
                      <div
                        nz-tooltip
                        nz-popover
                        [class.horizontal]="operation.direction === 'horizontal'"
                        [nzTooltipTitle]="getString(operation.tooltip)"
                        [nzPopoverTrigger]="operation.trigger || 'hover'"
                        [nzPopoverVisible]="operation.pagePicker ? operation.pagePicker.visible : false"
                        [nzPopoverContent]="operation.pagePicker ? pagePickerTpl : operation.ref ? customRef : undefined"
                        (nzPopoverVisibleChange)="onPagePickerVisibleChange(operation, $event)"
                        nzTooltipPlacement="bottom"
                      >
                        <div class="icon">
                          <i nz-icon [nzType]="getString(operation.icon)!"></i>
                        </div>
                        <div class="text">
                          <ng-container *ngIf="!operation.labelRef;else labelRef"> {{ this.getString(operation.label) }}</ng-container>
                          <ng-template #labelRef>
                          <m-operations-template [ref]="operation.labelRef!"></m-operations-template>
                        </ng-template>
                        </div>
                        <div *ngIf="getString(operation.iconRight)" class="icon-right">
                          <i nz-icon [nzType]="getString(operation.iconRight)!"></i>
                        </div>
                        <ng-template #customRef>
                          <m-operations-template [ref]="operation.ref!"></m-operations-template>
                        </ng-template>
                      </div>
                    </ng-template>
                  </div>
                  <div
                    *ngIf="operation.children"
                    class="m-operations-item-inner"
                    nz-dropdown
                    [nzDropdownMenu]="menu"
                    nzPopoverPlacement="bottom"
                    [nzDisabled]="operation.disabled ? operation.disabled() : false"
                    [class.disabled]="operation.disabled ? operation.disabled() : false"
                    [class.active]="operation.active ? operation.active() : false"
                  >
                    <div [class.horizontal]="operation.direction === 'horizontal'">
                      <div class="icon">
                        <i nz-icon [nzType]="getString(operation.icon)!" [style.fontSize]="operation.iconSize"></i>
                        <i
                          *ngIf="operation.direction !== 'horizontal' && getDropdownVisible(operation)"
                          nz-icon
                          nzType="caret-down"
                          nzTheme="outline"
                        ></i>
                      </div>
                      <div class="text">
                        {{ getString(operation.label) }}
                      </div>
                      <div class="icon">
                        <!-- 水平方向下拉箭头处于文字右边 -->
                        <i
                          *ngIf="operation.direction === 'horizontal' && getDropdownVisible(operation)"
                          nz-icon
                          nzType="caret-down"
                          nzTheme="outline"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <nz-dropdown-menu #menu>
                    <ul nz-menu>
                      <li
                        nz-menu-item
                        *ngFor="let child of operation.children"
                        class="m-operations-item-dropdown-item"
                        [class.m-operations-item-dropdown-item-active]="child.active ? child.active() : false"
                        [nzDisabled]="child.disabled ? child.disabled() : false"
                        (click)="onOperationClick(child)"
                      >
                        <i
                          *ngIf="getString(child.icon)"
                          nz-icon
                          [nzType]="getString(child.icon)!"
                          nzTheme="outline"
                          [style.fontSize]="operation.iconSize"
                        ></i>
                        <div>{{ getString(child.label) }}</div>
                      </li>
                    </ul>
                  </nz-dropdown-menu>
                </div>
                <ng-template #pagePickerTpl>
                  <ng-container *ngIf="operation.pagePicker">
                    <m-page-picker
                      #pagePicker
                      [mTotal]="total"
                      [mPageIndex]="currentPage"
                      [mPageConfig]="operation.pagePicker.pageConfig"
                      [(mType)]="operation.pagePicker.type"
                      [(mPageText)]="operation.pagePicker.pageText"
                      (mConfirm)="onPagePickerConfirm($event, operation)"
                      (mCancel)="onPagePickerCancel(operation)"
                    ></m-page-picker>
                  </ng-container>
                </ng-template>
              </nz-space-item>
              <div class="m-operations-item-divider" nzType="vertical" *ngIf="operation.divider">
                <div class="m-operations-item-divider-inner"></div>
              </div>
            </ng-container>
            <ng-container *ngIf="operation.buildIn">
              <nz-space-item [ngSwitch]="operation.buildIn">
                <div
                  class="m-operations-item {{ operation.classnames }}"
                  [class.disabled]="operation.disabled ? operation.disabled() : false"
                >
                  <m-operations-zoom
                    [mAreaType]="operation.areaType || 'headerArea'"
                    *ngSwitchCase="'zoom'"
                    (mZoomChange)="onZoomChange($event)"
                  ></m-operations-zoom>
                  <m-operations-rotation-left *ngSwitchCase="'rotationLeft'" (mRotateLeft)="onRotate(-90)"></m-operations-rotation-left>
                  <m-operations-rotation-right *ngSwitchCase="'rotationRight'" (mRotateRight)="onRotate(+90)"></m-operations-rotation-right>
                  <m-operations-pagination
                    *ngSwitchCase="'pagination'"
                    [mTotal]="total"
                    [mAreaType]="operation.areaType || 'headerArea'"
                    [mCurrentPage]="currentPage"
                    (mCurrentPageChange)="onCurrentPageChange($event)"
                  ></m-operations-pagination>
                  <m-operations-fullscreen *ngSwitchCase="'fullscreen'" [elementSelector]="mSelector"></m-operations-fullscreen>
                </div>
              </nz-space-item>
            </ng-container>
          </ng-container>
        </ng-container>
      </nz-space>
    </div>
  `,
  providers: [MOperationsTemplateService]
})
export class MOperationsComponent implements OnInit, OnDestroy {
  @Input() mHub?: LabelHub;
  @Input() mOperations: IMOperation[] = [];
  @Input() mRotationList: number[] = [];
  @Input() mSelector: string = '';

  @Output() readonly mRotationListChange = new EventEmitter<number[]>();
  @ViewChild(MOperationsFullscreenComponent) fullscreenComponent!: MOperationsFullscreenComponent;

  total = 1;
  currentPage = 1;
  cascaderText = '';
  private destroy$ = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (this.mHub) {
      this.mHub.pageNumber$.pipe(distinctUntilChanged(), takeUntil(this.destroy$)).subscribe(current => {
        this.currentPage = current;
        this.cdr.detectChanges();
      });
      this.mHub.pageCount$.pipe(distinctUntilChanged(), takeUntil(this.destroy$)).subscribe(total => {
        this.total = total;
        this.cdr.detectChanges();
      });
    }
  }

  getDropdownVisible(operation: IMOperation): boolean {
    if (operation.dropdownVisible) {
      return operation.dropdownVisible();
    }
    return true;
  }

  getString(str?: string | (() => string)): string | undefined {
    return typeof str !== 'function' ? str : str();
  }

  onOperationClick(operation: IMOperation): void {
    if (operation.onClick) {
      operation.onClick();
    }
  }

  onZoomChange(val: number): void {
    if (this.mHub) {
      this.mHub.setZoom(val);
    }
  }

  onPagePickerConfirm(pages: number[], operation: IMOperation): void {
    if (operation.pagePicker) {
      operation.pagePicker.onConfirm(pages);
      operation.pagePicker.visible = false;
      this.cdr.detectChanges();
    }
  }

  onPagePickerCancel(operation: IMOperation): void {
    if (operation.pagePicker) {
      if (operation.pagePicker.onCancel) {
        operation.pagePicker.onCancel();
      }
      operation.pagePicker.visible = false;
      this.cdr.detectChanges();
    }
  }

  onPagePickerVisibleChange(operation: IMOperation, visible: boolean): void {
    if (operation.pagePicker) {
      operation.pagePicker.visible = visible;
    }
  }

  onCascaderSelection(selectedOptions: NzCascaderOption[], operation: IMOperation): void {
    if (operation.cascader) {
      this.cascaderText = selectedOptions.map(o => o.label).join(', ');
    }
  }

  onCascaderChange(data: NzSafeAny, operation: IMOperation): void {
    if (operation.cascader && operation.cascader.selectedChange) {
      operation.cascader.selectedChange(data);
    }
  }

  /**
   * 只对当前页做旋转
   */
  onRotate(angle: number): void {
    if (this.mHub) {
      // rotationList 长度补齐
      const currentPage = this.mHub.pageNumber$.getValue();
      this.mRotationList = padRotationList(this.mRotationList, this.mHub.pageCount$.getValue());
      this.mRotationList[currentPage - 1] = (this.mRotationList[currentPage - 1] + angle) % 360;
      this.mHub.setRotation(this.mRotationList);
      this.mRotationListChange.emit([...this.mRotationList]);
    }
  }

  onCurrentPageChange(page: number): void {
    if (this.mHub) {
      this.mHub.setPageNumber(page);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  exitFullscreen(): void {
    if (this.fullscreenComponent && this.fullscreenComponent.fullscreen) {
      this.fullscreenComponent.exitFullscreen();
    }
  }
}
